export default __webpack_public_path__ + "static/media/news44.cf8b75b2.jpg";